// Instructions on how to import other JS files into this one.
// https://babeljs.io/learn-es2015/#modules
// http://exploringjs.com/es6/ch_modules.html
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/export

import Vue from 'vue'
import SocialSharing from 'vue-social-sharing'
import FeaturesFunctionality from './_vue/components/FeaturesFunctionality'
import Careers from './_vue/components/Careers'
import Leadership from './_vue/components/Leadership'
import Resources from './_vue/components/Resources'
import Viewer from './_vue/components/Viewer'

import 'babel-polyfill'
import 'jquery'
import 'modaal'

import * as header from './header'
import * as carousel from './carousel'
import * as video from './video'
import * as modals from './modals'
import * as tabs from './tabs'
import * as tables from './tables'
import * as fadable from './fadable'
import * as heroXPlatform from './hero-x-platform'
import * as heroForm from './hero-form'
import * as accordion from './accordion'
import * as copyUrl from './copy-url'
// import * as vmoTransform from './vmo-transform'

Vue.use(SocialSharing)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    delimiters: ['${', '}'],
    mounted() {
        header.initialize()
        carousel.initialize()
        video.initialize()
        modals.initialize()
        tabs.initialize()
        tables.initialize()
        fadable.initialize()
        heroXPlatform.initialize()
        heroForm.initialize()
        accordion.initialize()
        copyUrl.initialize()
        // vmoTransform.initialize()
    },
    components: {
        'features-functionality': FeaturesFunctionality,
        'careers': Careers,
        'resources': Resources,
        'viewer': Viewer,
        'leadership': Leadership
    }
})
